function e(n) {
  return n != null;
}
function r(n) {
  return /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi.test(n);
}
export {
  e as isDef,
  r as isKorean
};
